module.exports = __webpack_public_path__ + "img/pre-pass.3219dd37.svg";